module.exports = __webpack_public_path__ + "img/coding-demo.c91d96d7.png";